<script setup lang="ts">
import { ref } from 'vue'
import { NLayout, NLayoutContent, NLayoutHeader, NGrid, NGi, NSwitch } from 'naive-ui'
import SignupForm from "@/components/SignupForm.vue";

import { augmentifyLogo } from "@/assets/utils/icons";

const active = ref(true)

</script>

<template>
  <n-layout>
    <n-layout-header class="header grid-container text-align-center">
      <div v-html="augmentifyLogo"></div>
    </n-layout-header>

    <n-layout-content  content-class="login-layout grid-container">
      <n-grid x-gap="12" :cols="12" item-responsive responsive="screen">

        <n-gi span="12 s:6 m:6 l:7" class="height-100 flex-center">
          <div class="image-container">
            <img class="login-image" src="../assets/signup/signup-img.png"/>

            <span class="augmentify-welcome-message">
              <span>Welcome to </span>
              <span class="augmentify-text">Augmentify</span>
              <n-switch v-show="false" v-model:value="active" size="medium"></n-switch>
            </span>
          </div>
        </n-gi>

        <n-gi span="12 s:6 m:5 l:4" offset="m:1">
          <signup-form></signup-form>
        </n-gi>

      </n-grid>
    </n-layout-content>
  </n-layout>
</template>

<style lang="scss">
.login-image {
  width: 100%;
  object-fit: contain;
  object-position: center;
}

.login-layout {
  height: calc(100vh - 98px) !important;
  padding-bottom: 80px;

  .image-container {
    position: relative;

    .augmentify-welcome-message {
      left: 0;
      bottom: 0;
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      font-size: 43.2px;
      font-style: normal;
      font-weight: 700;
      line-height: 73.934px;
      white-space: pre-wrap;

      .augmentify-text {
        font-size: 65.7px;
        margin-bottom: 24px;
      }
    }
  }
}

.header {
  padding: 40px 0 30px;
}

.form-wrapper {
  .input-group {
    display: grid;
    gap: 10px;
  }

  .icon-full {
    height: 100%;
    width: 100%;
  }
}

.registration-warning {
  margin-bottom: 75px;
}

.page-title {
  margin-bottom: 30px;
}


</style>